export enum ShareRole {
	READ = "READ",
	EDIT = "EDIT",
}
